import api from "@/api/";
import { PaginationModel } from "../types";

export default class FcmTokenApi {

  static async send(data:any) {
    return await api.post(`fcm/push-token`,data);
  }
}
